export default __webpack_public_path__ + "static/media/favicon.23741627.png";